export const defaultLabelGetter = item => {
  return item ? item.label : '';
};
const defaultFilterBy = (item, inputValue) => item.includes(inputValue);
export const defaultGetFilteredItems = _ref => {
  let {
    allItems,
    itemToString,
    inputValue,
    filterBy = defaultFilterBy
  } = _ref;
  if (!inputValue) {
    return allItems;
  }
  return allItems.filter(item => filterBy(itemToString(item).toLowerCase(), inputValue.toLowerCase()));
};
export const defaultIsItemDisabled = item => !!item.disabled;
//# sourceMappingURL=defaultGetters.js.map